module.exports = __webpack_public_path__ + "img/krathong_10.ec82b56a.png";